//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CCFRA',
  data () {
    return {
      form: {
        morning_rigor: '0',
        arthritis3: '0',
        chiroarthritis: '0',
        symmetrical_arthritis: '0',
        rheumatoid_nodules: '0',
        rheumatoid_factor_positive: '0',
        radiological: '0',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/CCFRA.vue